import {Fields} from '@vuex-orm/core';
import {StembleModel} from '@/common/models/StembleModel';

/**
 * QuestionResponse class
 */
export class QuestionResponse extends StembleModel {
  id!: number;

  static fields(): Fields {
    return {
      id: this.number(null),
    };
  }
}

export default QuestionResponse;
